/* eslint-disable */
import { Http } from '../library';
import { httpMethods } from '../enums';
import * as Endpoints from '../constants/endpoints.constant';
import api from '../api/client';
import {
  NEBK_UPI_VERIFY,
  REQUEST_OTP,
  RESEND_WITHDRAW_OTP,
  VERIFY_OTP,
  VERIFY_WITHDRAW_OTP,
} from '../constants/endpoints.constant';

class WalletService {
  /**
   * Get UPI providers
   */
  async getUPIProvider() {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(Endpoints.UPI_PROVIDER)
      .request();
  }

  /**
   * Order from razorpay UPI
   * @param data
   */
  async orderRazorpayUPI(data: any,userId:any) {
    const newdata = {...data,user_id:userId}
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(Endpoints.RAZORPAY_UPI_ORDER)
      .setData(newdata)
      .setToken(api.getToken())
      .request();
  }

  /**
   * Verify razorpay UPI payment
   * @param data
   */
  async verifyUPIANDNEBT(data: any) {
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(Endpoints.NEBK_UPI_VERIFY)
      .setData(data)
      .setToken(api.getToken())
      .request();
  }

  /**
   * Order from razorpay net banking
   * @param data
   */
  async orderRazorpayNetBanking(data: any) {
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(Endpoints.RAZORPAY_NET_BANKING_ORDER)
      .setData(data)
      .setToken(api.getToken())
      .request();
  }

  /**
   * Verify razorpay net banking payment
   * @param data
   */
  async verifyRazorpayNetBanking(data: any) {
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(Endpoints.RAZORPAY_NET_BANKING_VERIFY)
      .setData(data)
      .setToken(api.getToken())
      .request();
  }

  /**
   * Order from dbs UPI
   * @param data
   */
  async add(data: any,userId:any) {
    const newdata = {...data,user_id:userId}
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(Endpoints.DBS_UPI)
      .setData(newdata)
      .setToken(api.getToken())
      .request();
  }

  /**
   * Withdraw money
   * @param data
   */
  async withdraw(data: any) {
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(Endpoints.WITHDRAW)
      .setData(data)
      .request();
  }
  async withdrawPending(data: any,userId:any) {
    const newdata = {...data,user_id:userId}
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(Endpoints.WITHDRAW_PENDING)
      .setData(newdata)
      .request();
  }

  async requestOtp(data: any,userId:any) {
    const newdata = {...data,user_id:userId}
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(Endpoints.REQUEST_OTP)
      .setData(newdata)
      .request();
  }

  async verifyOtp(data: any) {
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(Endpoints.VERIFY_WITHDRAW_OTP)
      .setData(data)
      .request();
  }

  async sendOtp(id: any) {
    return await Http.setMethod(httpMethods.patch)
      .unsetData()
      .setUrl(Endpoints.RESEND_WITHDRAW_OTP)
      .setData({
        transactionId: id,
        isTestEnv: true, //TODO remove after testing
      })
      .request();
  }
}

export default new WalletService();
